const upcomingEventsMessage = {
  enabled: false,

  title: "Event Schedule Update",

  message:
    "Some of our upcoming events are being rescheduled. Please check back soon for updated dates and event information."
};

export default upcomingEventsMessage;